import { useParallax } from '../../PromptCard/useParallax';

const SCALE_X = 1.03;
const SCALE_Y = 1.03;

type UseAchievementCardHoverProps = {
    needHover: boolean;
    backgroundImageUrl: string;
    owned: boolean;
};

export const useAchievementCardParallax = ({ needHover, backgroundImageUrl, owned }: UseAchievementCardHoverProps) => {
    const { panelRef, subpanelRef, transformX, transformY, isHovered } = useParallax(1);

    const parallaxStyle = {
        transform: `perspective(200px) rotateY(${transformX}deg) rotateX(${transformY}deg)`,
    };

    const cardParallaxStyle = needHover ? parallaxStyle : {};

    const backgroundHoverStyle =
        needHover && isHovered ? ({ transform: `scale(${SCALE_X}, ${SCALE_Y})` } as React.CSSProperties) : {};

    const backgroundStyle = {
        '--bg-image': owned ? `url(${backgroundImageUrl})` : '',
        ...backgroundHoverStyle,
    };

    return {
        panelRef,
        subpanelRef,
        cardParallaxStyle,
        backgroundStyle,
    };
};
